<template>
    <div>
        <Modal v-model="modal" :title="!logWarningForm.id ? this.$t('alarms.log.application.addLogAlarm'):this.$t('alarms.log.application.editLogAlarm')" @on-cancel="cancel" @on-ok="ok"  :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="800px" :footer-hide="true" :closable="false">
            <Form ref="logWarningForm" :model="logWarningForm" :label-width="110" :rules="ruleValidate" >
                <!-- 下一步 -->
                <div v-show="isNext">
                    <!-- 微信警告 -->
                    <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
                    <!-- 规则名称 -->
                    <FormItem :label="this.$t('alarms.common.alertRuleName')" prop="ruleName" v-if="isEditRuleName">
                        <Row>
                            <Col span="11">
                                <Input type="text" v-model="logWarningForm.ruleName" placeholder="Enter something..." style="width:300px;" :disabled="isEdit"></Input>
                            </Col>
                        </Row>
                    </FormItem>

                    <!-- 规则名称 -->
                    <FormItem :label="this.$t('alarms.common.alertRuleName')" v-if="showRuleName">
                        <Row>
                            <Col span="24">
                                <div>{{this.logWarningForm.ruleName}}</div>
                            </Col>
                        </Row>
                    </FormItem>

                    <!-- 规则描述 -->
                    <FormItem :label="this.$t('alarms.common.alertRuleDesc')">
                        <Row :gutter="4">
                            <!-- 监控指标 -->
                            <Col span="4">
                                <FormItem prop="monitorIndex">
                                    <Select v-model="logWarningForm.monitorIndex" filterable @on-change="changeMonitorIndex(logWarningForm.monitorIndex)">
                                        <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 周期 -->
                            <Col span="3">
                                <FormItem prop="cycle">
                                    <Select v-model="logWarningForm.cycle" filterable :placeholder="this.$t('alarms.common.cycle')" @on-change="changeCycle(logWarningForm.cycle)" >
                                        <Option :value="item.id" v-for="(item,index) in cycleList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 连续周期 -->
                            <Col span="4">
                                <FormItem prop="continousCycle">
                                    <Select v-model="logWarningForm.continousCycle" filterable :placeholder="this.$t('alarms.common.continuous')" @on-change="changeContinousCycle(logWarningForm.continousCycle)">
                                        <Option :value="item.id" v-for="(item,index) in continousCycleList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 统计数值 -->
                            <Col span="4">
                                <FormItem prop="statisticsValue">
                                    <Select v-model="logWarningForm.statisticsValue" filterable :placeholder="this.$t('alarms.common.statisticsValue')" @on-change="changeStatisticsValue(logWarningForm.statisticsValue)">
                                        <Option :value="item.id" v-for="(item,index) in statisticsValueList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 关系符号 -->
                            <Col span="3">
                                <FormItem prop="relationshipSign">
                                    <Select v-model="logWarningForm.relationshipSign" filterable :placeholder="this.$t('alarms.common.sign')" @on-change="changeRelationshipSign(logWarningForm.relationshipSign)">
                                        <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 报警关键字 -->
                            <Col span="3">
                                <FormItem prop="thresholdValue">
                                    <Input v-model="logWarningForm.thresholdValue" :placeholder="this.$t('alarms.log.keyword')"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                    </FormItem>

                    <!-- 联系方式 -->
                    <FormItem :label="this.$t('alarms.billing.contactWay')" prop="contactType">
                        <RadioGroup v-model="logWarningForm.contactType" @on-change="changeContactType(logWarningForm.contactType)" :placeholder="this.$t('alarms.common.pleaseSelect')">
                            <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
                        </RadioGroup>
                    </FormItem>

                    <!-- 通知对象 -->
                    <FormItem :label="this.$t('alarms.common.contact')" prop="notificationObject" v-if="logWarningForm.contactType==0">
                        <Select v-model="logWarningForm.notificationObject" filterable multiple style="width:300px;" @on-change="changeNotificationObject" :placeholder="this.$t('alarms.common.pleaseSelect')">
                            <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>

                    <!-- 联系人组 -->
                    <FormItem :label="this.$t('alarms.common.alertContactGroup')" prop="contactGroupIds" v-if="logWarningForm.contactType==1">
                        <Select v-model="logWarningForm.contactGroupIds" filterable multiple style="width:300px;" @on-change="changeContactGroupId(logWarningForm.contactGroupIds)" :placeholder="this.$t('alarms.common.pleaseSelect')">
                            <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>

                    <!-- 报警方式 -->
                    <FormItem :label="this.$t('alarms.common.alarmType')" prop="noticeType">
                      <Select v-model="logWarningForm.noticeType" filterable multiple style="width:300px;" @on-change="selectnoticeType(logWarningForm.noticeType)" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                      </Select>
                    </FormItem>

                    <!-- 企业微信机器人URL -->
                    <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="logWarningForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
                        <Select v-model="logWarningForm.enterpriseWechatRobotIds" filterable multiple style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
                            <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>

                    <!-- 延迟告警 -->
                    <FormItem :label="this.$t('alarms.common.delayAlarm')" prop="alarmDelay">
                        <Select v-model="logWarningForm.alarmDelay" filterable style="width:300px;" :placeholder="this.$t('alarms.common.monitorIndex')">
                          <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>

                  <!-- 监控时段 -->
                  <FormItem :label="this.$t('alarms.common.monitoringTime')" prop="monitorPeriod">
                    <Select v-model="logWarningForm.monitorPeriod" filterable style="width:300px;" :placeholder="this.$t('alarms.common.pleaseSelect')">
                      <Option v-for="item in monitorPeriodList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                  </FormItem>

                    <!-- 邮箱模板 -->
                    <div v-show="isShowEmail">
                        <FormItem :label="this.$t('alarms.common.emailTemplate')" prop="emailModal">
                            <Input v-model="logWarningForm.emailModal" type="textarea" :autosize="{minRows: 2,maxRows: 5}"  style="width:665px;" disabled></Input>
                        </FormItem>
                    </div>

                    <!-- 企业微信模板 -->
                    <div v-show="isShowWeChat">
                        <FormItem :label="this.$t('alarms.common.weChatTemplate')" prop="wechatModal">
                            <Input v-model="logWarningForm.wechatModal" type="textarea" :autosize="{minRows: 2,maxRows: 5}"  style="width:665px;" disabled></Input>
                        </FormItem>
                    </div>
                    <div style="height: 42px;">
                        <Button type="primary" size="large" style="float: right;"  @click="ok('logWarningForm')" :loading="addloading" :disabled="isAddOrEdit">{{!logWarningForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}</Button>
                        <Button size="large"  style="float: right;margin-right: 10px;" @click="cancel('logWarningForm')">{{ $t('alarms.common.cancel') }}</Button>
                        <Button size="large" @click="previousPage" style="float: right;margin-right: 10px;">{{ $t('alarms.common.lastStep') }}</Button>
                    </div>
                </div>

                <!-- 上一步 -->
                <div v-show="isPrevious">
                    <div>
                        <Row :gutter="16">
                            <Col span="8">
                                <!-- 账户 -->
                                <FormItem :label="this.$t('alarms.common.account')" prop="account" :label-width="70">
                                    <Select v-model="logWarningForm.account" filterable @on-change="changeAccount(logWarningForm.account)" :transfer="true" placeholder="">
                                        <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col span="8" style="z-index: 200">
                                <!-- 存储区域 -->
                                <FormItem :label="this.$t('alarms.common.region')" prop="backupRegion">
                                    <Select @on-change="changebackupRegion(logWarningForm.backupRegion)" v-model="logWarningForm.backupRegion" filterable multiple :max-tag-count="1" :transfer="true" placeholder="">
                                        <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                                        <Option  :value="item.name" v-for="item in backupRegionList" :key="item.id">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col span="5">
                                <!-- 标签 -->
                                <FormItem :label="this.$t('alarms.common.tags')" prop="tags" :label-width="40">
                                    <Input  v-model="logWarningForm.tags" placeholder="" />
                                </FormItem>
                            </Col>
                            <Button type="primary" style="float: right;" v-show="isShowSearch" @click="searchLogDate">{{ $t('alarms.common.search')  }}</Button>
                        </Row>
                    </div>

                    <v-table :height="459" column-width-drag is-horizontal-resize style="width:100%;height:459px;margin-bottom: 15px;" :columns="column" :table-data="tableLogDate" row-hover-color="#edf7ff" :is-loading="modal_loadings" title-bg-color="#f8f8f9" :select-group-change="selectChange" :select-all="selectAll"></v-table>
                    <div style="height: 42px;">
                        <Button type="primary" size="large" @click="nextPage" style="float: right;" :disabled="isNextClick">{{ $t('alarms.common.nextStep') }}</Button>
                        <Button size="large"  style="margin-right: 10px;float: right;" @click="cancel('logWarningForm')">{{ $t('alarms.common.cancel') }}</Button>
                    </div>
                </div>
            </Form>
        </Modal>
    </div>
</template>
<script>
    import WechatWarning from '../../common/WechatWarning.vue'
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import TableLog from '../log/TableLog.vue'
    var tableLog = TableLog;
    var tableLogWarningVue = {}
    export default {
        inject:['reload'],
        components: {
            WechatWarning
        },
        data () {
            // 名字是否重复
            var validNameRepeatedCheck = (rule, value, callback) =>{
                var self = this;
                self.$api.alertRule.nameRepeatedCheck({
                    "alertRuleName": this.logWarningForm.ruleName,
                    "monitorModule": this.monitorModule
                })
                .then(res => {
                    if(res.status==200){
                        callback();
                    }
                })
                .catch(err =>{
                    if(err.status==400){
                        callback(new Error(this.$t('monitor.alarmRule.ruleNameRepeated')));
                    }
                })
            };
            return {
                monitorModule:13,
                isAddOrEdit:true,
                wechatWarningVisible: false,
                contactTypeList: [{
                    label: this.$t('alarms.common.alertContact'),
                    value: 'contact',
                    type: 0
                },
                {
                    label: this.$t('alarms.common.alertContactGroup'),
                    value: 'contactGroup',
                    type: 1
                }],
                addloading:false,
                singleBackupRegion:false,
                alarmDelayList:[],
                monitorPeriodList:[],
                isEdit:false,
                isShowSearch:false,
                isEditRuleName:false,
                showRuleName:false,
                modal_loadings: false,
                isShowEmail:false,
                isShowWeChat:false,
                isNext:false,
                isPrevious:true,
                selection:[],
                accountList: [],
                notificationObjectList: [],
                backupRegionList:[],
                alarmWayList: [],
                loading: true,
                modal:false,
                modal_loading: false,
                exportDataList:'',
                noticeType:[],
                isNextClick:true, //禁止点击下一步
                state:["pending","running","stopping","stopped","shutting down","terminated"],
                logWarningForm: {
                    account:'',
                    ruleName: '',
                    notificationObject: [],
                    noticeType:[],
                    emailModal:'',
                    wechatModal:'',
                    thresholdValue:'',
                    monitorIndex:'',
                    cycle:'',
                    continousCycle:'',
                    statisticsValue:'',
                    relationshipSign:'',
                    backupRegion:[],
                    tags:'',
                    alarmDelay:'',
                    monitorPeriod:'',
                    contactType:0,
                    contactGroupIds:[],
                    userIdList:[],
                    enterpriseWechatRobotIds:[]
                },
                enterpriseWechatRobotIdsList:[],
                // 联系人组
                contactGroupIdList:[],
                // 监控指标
                monitorIndexList: [],
                // 周期
                cycleList: [],
                // 连续周期
                continousCycleList: [],
                // 统计数值
                statisticsValueList: [],
                // 关系符号
                relationshipSignList: [],
                ruleValidate: {
                    account: [
                        { required: true, message: this.$t('monitor.alarmRule.accountRequired'), trigger: 'change',type:'number' }
                    ],
                    alarmDelay: [
                        {required: true, message: this.$t('monitor.alarmRule.alarmDelayRequired'), trigger: 'change', type: 'number'}
                    ],
                  monitorPeriod: [
                    {required: true, message: this.$t('monitor.alarmRule.monitorPeriodRequired'), trigger: 'change', type: 'number'}
                  ],
                    backupRegion: [
                        {required: true, type: 'array', message: this.$t('monitor.alarmRule.regionRequired'), trigger: 'change'}
                    ],
                    ruleName: [
                        { required: true, message: this.$t('monitor.alarmRule.ruleNameRequired'), trigger: 'blur' },
                        { type: 'string', message: this.$t('monitor.alarmRule.ruleNamePattern'), pattern:'^[^ ]{2,20}$', trigger: 'blur'},
                        { validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    notificationObject: [
                        { required: true, type: 'array',message: this.$t('monitor.alarmRule.notificationObjectRequired')}
                    ],
                    noticeType: [
                        { required: true, type: 'array', min: 1, message: this.$t('monitor.alarmRule.noticeTypeRequired'), trigger: 'change' }
                    ],
                    monitorIndex: [
                        { required: true, message: this.$t('monitor.alarmRule.monitorIndexRequired'), trigger: 'change',type:'number' }
                    ],
                    cycle: [
                        { required: true, message: this.$t('monitor.alarmRule.cycleRequired'), trigger: 'change',type:'number' }
                    ],
                    continousCycle: [
                        { required: true, message: this.$t('monitor.alarmRule.continousCycleRequired'), trigger: 'change',type:'number' }
                    ],
                    statisticsValue: [
                        { required: true, message: this.$t('monitor.alarmRule.statisticsValueRequired'), trigger: 'change',type:'number' }
                    ],
                    relationshipSign: [
                        { required: true, message: this.$t('monitor.alarmRule.relationshipSignRequired'), trigger: 'change',type:'number' }
                    ],
                    thresholdValue: [
                        { required: true, message: this.$t('monitor.alarmRule.alarmKeywordRequired'),trigger: 'blur'}
                    ],
                    contactType: [
                        {required: true, message: this.$t('monitor.alarmRule.contactTypeRequired'), trigger: 'change', type: 'number'}
                    ],
                    contactGroupIds: [
                        {required: true, message: this.$t('monitor.alarmRule.contactGroupRequired'), trigger: 'change', type: 'array'}
                    ],
                    enterpriseWechatRobotIds: [
                        {required: true, type: 'array', message: this.$t('monitor.alarmRule.enterpriseWechatRobotRequired'), trigger: 'change'}
                    ]
                },
                column: [
                    {   width: 60,
                        titleAlign: 'center',
                        columnAlign:'center',
                        type: 'selection'
                    },
                    {
                        field: 'instanceId',
                        title: this.$t('alarms.log.application.instanceId'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'name',
                        title: this.$t('alarms.log.application.name'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'privateIp',
                        title: this.$t('alarms.log.application.ip'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'state',
                        title: this.$t('alarms.common.status'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    },
                    {
                        field: 'region',
                        title: this.$t('alarms.log.application.region'),
                        width: 80,
                        titleAlign: 'center',
                        columnAlign: 'center',
                        isResize: true
                    }
                ],
                tableLogDate:[],
                newTableLogDateList:[],
                compareInstanceList:[]
            }
        },

        beforeCreate: function () {
            tableLogWarningVue = this
        },
        methods:{
            //显示表格数据
            /****************************************************************/
            showTableLog: function () {
                for (var i=0; i<this.tableLogDate.length; i++) {
                    // 状态
                    if (this.tableLogDate[i].state == 0) {
                        this.tableLogDate[i].state = 'pending';
                    } else if (this.tableLogDate[i].state == 1) {
                        this.tableLogDate[i].state = 'running';
                    } else if (this.tableLogDate[i].state == 2) {
                        this.tableLogDate[i].state = 'stopping';
                    } else if (this.tableLogDate[i].state == 3) {
                        this.tableLogDate[i].state = 'stopped';
                    } else if (this.tableLogDate[i].state == 4) {
                        this.tableLogDate[i].state = 'shutting down';
                    } else if (this.tableLogDate[i].state == 5) {
                        this.tableLogDate[i].state = 'terminated';
                    }
                }
            },
            // 下一步
            nextPage: function(){
                this.isNext=true;
                this.isPrevious=false;
                // 查询监控指标
                tableLogWarningVue.searchMonitorIndex();
                // 查询阈值
                tableLogWarningVue.selectMonitorIndexDefault();
                // 查询联系人组
                tableLogWarningVue.listContactGroups();
            },
            // 上一步
            previousPage: function(){
                this.isNext=false;
                this.isPrevious=true;
            },
            init: function(id){
                this.logWarningForm.id = id || 0;
                // 根据用户名查询Account列表
                tableLogWarningVue.getAccount();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['logWarningForm'].resetFields();
                    if(this.logWarningForm.id){
                        // 编辑显示不能输入的规则名称
                        this.showRuleName=true;
                        this.isEdit=true;
                        this.isShowSearch=false;
                        this.$api.alertRule.selectAlertRule("id",this.logWarningForm.id)
                        .then(res => {
                            //延时
                            this.logWarningForm.alarmDelay = res.data.delay;
                            //监控时段
                            this.logWarningForm.monitorPeriod = res.data.monitorPeriod;
                            // 账户
                            /******************************************************/
                            this.logWarningForm.account=res.data.accountId;
                            tableLogWarningVue.$api.account.queryAccountRegions("accountId",this.logWarningForm.account)
                            .then(res => {
                                this.backupRegionList = res.data;
                            });

                          tableLogWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                            "monitorModule":this.monitorModule,
                            "accountId":this.logWarningForm.account
                          })
                            .then(res => {
                              this.notificationObjectList = res.data.contactList;
                            });

                            this.modal_loadings = true;
                            setTimeout(() => {
                                // 存储区域
                                this.logWarningForm.backupRegion=res.data.regions;

                                // 实例列表
                                /******************************************************/
                                this.instanceList=res.data.instanceList;
                                this.compareInstanceList=res.data.instanceList;
                                // 根据AccountId查询Instance列表
                                tableLogWarningVue.$api.instance.queryInstanceByGroup({
                                    "regions": this.logWarningForm.backupRegion,
                                    "accountId": this.logWarningForm.account
                                })
                                .then(res => {
                                    this.tableLogDate=res.data.instanceDTOS;
                                    tableLogWarningVue.showTableLog();
                                    this.modal_loadings = false;
                                    for(var i=0;i<this.tableLogDate.length;i++){
                                        for(var j=0;j<this.compareInstanceList.length;j++){
                                            if(this.tableLogDate[i].instanceId==this.compareInstanceList[j].instanceId){
                                                this.tableLogDate[i]._checked=true;
                                            }
                                        }
                                    }
                                    // 选了数据 可以点击下一步
                                    if(this.tableLogDate.length==0||this.compareInstanceList.length==0){
                                        this.isNextClick=true;
                                    }else{
                                        this.isNextClick=false;
                                    }
                                })
                            }, 1000)

                            this.newTableLogDateList=res.data.instanceList;

                            // 规则名称
                            this.logWarningForm.ruleName=res.data.alertRuleName;
                            // 监控指标
                            this.logWarningForm.monitorIndex=res.data.monitorIndex;
                            // 周期
                            this.logWarningForm.cycle=res.data.cycle;
                            // 连续周期
                            this.logWarningForm.continousCycle=res.data.continousCycle;
                            // 统计数值
                            this.logWarningForm.statisticsValue=res.data.statisticsValue;
                            // 符号
                            this.logWarningForm.relationshipSign=res.data.relationshipSign;
                            // 报警关键字
                            this.logWarningForm.thresholdValue=res.data.thresholdStringValue;
                            // 单位
                            this.logWarningForm.unit=res.data.unit;
                            this.units=res.data.unitId;
                            // 企业微信机器人URL
                            this.logWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

                            // 联系方式
                            this.logWarningForm.contactType = res.data.contactType;
                            if(res.data.contactType==0){
                                // 通知对象
                                this.logWarningForm.notificationObject=res.data.contactIDs;
                                for(var i=0;i<this.logWarningForm.notificationObject.length;i++){
                                    for(var j=0;j<this.notificationObjectList.length;j++){
                                        if(this.logWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                                            this.logWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                                        }
                                    }
                                }
                            }else if(res.data.contactType==1){
                                // 联系人组
                                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.logWarningForm.account)
                                .then(res => {
                                    this.contactGroupIdList = res.data;
                                })
                                setTimeout(() => {
                                    this.logWarningForm.contactGroupIds = res.data.contactGroupIds;
                                }, 1000)
                            }

                          // 报警方式
                          this.logWarningForm.noticeType = res.data.noticeType;
                          for (var i = 0; i < this.logWarningForm.noticeType.length; i++){

                            if (this.logWarningForm.noticeType[i] == '0') {
                              this.isShowEmail = true;
                              this.logWarningForm.emailModal = res.data.briefReportBodyMail;
                              this.noticeType = this.logWarningForm.noticeType;
                              tableLogWarningVue.selectTemplate();
                            }
                            if (this.logWarningForm.noticeType[i] == '1') {
                              // this.isShowWeChat = true;
                              this.logWarningForm.wechatModal = res.data.briefReportBodyWechat;
                              this.checkLeastOnePersonBoundWeChat();
                              this.noticeType = this.logWarningForm.noticeType;
                              tableLogWarningVue.selectTemplate();
                            }else if(this.logWarningForm.noticeType[i]!='1'){
                              this.wechatWarningVisible=false;
                              this.isAddOrEdit=false;
                          }

                          }
                        })
                    }else{
                        this.tableLogDate=[];
                        this.isEdit=false;
                        this.isShowSearch=true;
                        // 添加显示规则名称能输入
                        this.isEditRuleName=true;
                        this.showRuleName=false;
                    }
                })
                this.modal=true;
                this.isNext=false;
                this.isPrevious=true;
            },
            // 根据监控指标 显示不同单位
            /****************************************************************/
            // 清空周期、连续周期、统计数值、关系符号
            emptyDate: function(){
                this.logWarningForm.cycle='';
                this.logWarningForm.continousCycle='';
                this.logWarningForm.statisticsValue='';
                this.logWarningForm.relationshipSign='';
            },
            isNotEmpty: function (obj){
                if(typeof obj === "undefined" || obj === null || obj === "")
                {
                    return false;
                }else{
                    return true;
                }
            },
            // 根据监控指标 显示不同单位
            changeMonitorIndex: function(){
                tableLogWarningVue.selectTemplate();
                tableLogWarningVue.emptyDate();
            },
            // 查询阈值
            /****************************************************************/
            selectMonitorIndexDefault: function(){
                if(this.logWarningForm.account==""||this.logWarningForm.account==null){
                    return;
                }
                tableLogWarningVue.$api.alertRule.selectMonitorIndexDefault({
                    "monitorIndex": this.logWarningForm.monitorIndex,
                    "monitorModule": this.monitorModule,
                    "cycle":this.logWarningForm.cycle,
                    "continousCycle":this.logWarningForm.continousCycle,
                    "statisticsValue":this.logWarningForm.statisticsValue,
                    "relationshipSign":this.logWarningForm.relationshipSign,
                    "accountId": this.logWarningForm.account
                })
                .then(res => {
                    // 周期
                    this.cycleList=res.data.cycleMap;
                    // 连续周期
                    this.continousCycleList=res.data.continousCycleMap;
                    // 统计数值
                    this.statisticsValueList=res.data.statisticsValueMap;
                    // 关系符号
                    this.relationshipSignList=res.data.relationshipSignMap;
                })
            },
            // 查询邮件模板
            /****************************************************************/
            selectTemplate: function(){
                tableLogWarningVue.$api.briefReport.selectTemplate({
                    "monitorIndex": this.logWarningForm.monitorIndex,
                    "relationshipSign":this.logWarningForm.relationshipSign,
                    "monitorModule": this.monitorModule,
                    "noticeType":this.logWarningForm.noticeType
                })
                .then(res => {
                    this.logWarningForm.wechatModal=res.data.briefReportBodyWechat;
                    this.logWarningForm.emailModal=res.data.briefReportBodyMail;
                })
            },
            //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
            selectnoticeType: function(){
              this.isShowEmail = false;
              this.isShowWeChat = false;
              for(var i=0;i<this.logWarningForm.noticeType.length;i++) {
                if (this.logWarningForm.noticeType[i] == '0') {
                  this.isShowEmail = true;
                  this.noticeType = this.logWarningForm.noticeType;
                  tableLogWarningVue.selectTemplate();
                }
                if (this.logWarningForm.noticeType[i] == '1') {
                  // this.isShowWeChat = true;
                  this.noticeType = this.logWarningForm.noticeType;
                  this.checkLeastOnePersonBoundWeChat();
                  tableLogWarningVue.selectTemplate();
                }else if(this.logWarningForm.noticeType[i]!='1'){
                    this.wechatWarningVisible=false;
                    this.isAddOrEdit=false;
                }
              }
            },
            // 检查至少有一人绑定过微信
            checkLeastOnePersonBoundWeChat:function(){
              for(var i=0;i<this.logWarningForm.noticeType.length;i++){
                  if(this.logWarningForm.noticeType[i]==1){
                      var weChatDate={
                          "contactType":this.logWarningForm.contactType
                      };
                      // 联系方式为 -联系人-
                      if(this.logWarningForm.contactType==0){
                          weChatDate.userIds=this.logWarningForm.userIdList;
                      }
                      // 联系方式为 -联系人组-
                      else if(this.logWarningForm.contactType==1){
                          weChatDate.contactGroupIds = this.logWarningForm.contactGroupIds;
                      }
                      this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                      .then(res => {
                          if(res.data){
                            // 可以添加告警
                            this.wechatWarningVisible=false;
                            this.isAddOrEdit=false;
                          }else{
                            // 不可以添加微信告警
                            this.wechatWarningVisible=true;
                            this.isAddOrEdit=true;
                          }
                      })
                  }else if(this.logWarningForm.noticeType[i]!=1){
                      this.wechatWarningVisible=false;
                      this.isAddOrEdit=false;
                  }
              }
            },
            // 联系人组
            listContactGroups:function(){
                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.logWarningForm.account)
                .then(res => {
                    this.contactGroupIdList = res.data;
                })
            },
            // 切换联系人组
            changeContactGroupId:function(){
               this.checkLeastOnePersonBoundWeChat();
            },
            // 切换通知对象
            changeNotificationObject:function(val){
              this.logWarningForm.userIdList=[];
              this.logWarningForm.notificationObject=val;
              for(var i=0;i<this.logWarningForm.notificationObject.length;i++){
                for(var j=0;j<this.notificationObjectList.length;j++){
                  if(this.logWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                     this.logWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                  }
                }
              }
              this.checkLeastOnePersonBoundWeChat();
            },
            // 切换联系方式
            changeContactType:function(){
              this.checkLeastOnePersonBoundWeChat();
            },
            //点击查询 加载全部数据
            /***********************************************************************************/
            searchLogDate: function(){
                 if(this.logWarningForm.account==""||this.logWarningForm.account==null||this.logWarningForm.backupRegion==""||this.logWarningForm.backupRegion==null){
                    return;
                }
                this.modal_loadings = true;
                // 根据AccountId查询Instance列表
                tableLogWarningVue.$api.instance.queryInstanceByGroup({
                    "regions": this.logWarningForm.backupRegion,
                    "accountId": this.logWarningForm.account,
                    "tags": this.logWarningForm.tags
                })
                .then(res => {
                    this.tableLogDate=res.data.instanceDTOS;
                    tableLogWarningVue.showTableLog();
                    this.modal_loadings = false;
                })
            },

            /**************************************  查询  **************************************/
            // 查询监控指标
            searchMonitorIndex: function(){
                tableLogWarningVue.$api.alertRule.searchMonitorIndex({
                  "monitorModule":this.monitorModule,
                  "accountId":this.logWarningForm.account
                })
                .then(res => {
                    this.monitorIndexList = res.data;
                    this.logWarningForm.monitorIndex=this.monitorIndexList[0].id;
                })
            },
            // 查询通知对象
            queryContacts: function(){
                tableLogWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                  "monitorModule":this.monitorModule,
                  "accountId":this.logWarningForm.account
                })
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                    this.logWarningForm.notificationObject=res.data.defaultContactIds;
                })
            },
          // 查询报警方式
          alarmWay: function () {
            tableLogWarningVue.$api.alertRule.alarmWay("userName",getCookie(global.cookieName))
              .then(res => {
                this.alarmWayList = res.data;
              })
          },
            // 周期
            changeCycle: function(){
                // 查询阈值
                tableLogWarningVue.selectMonitorIndexDefault();
            },
            // 连续周期
            changeContinousCycle: function(){
                // 查询阈值
                tableLogWarningVue.selectMonitorIndexDefault();
            },
            // 统计数值
            changeStatisticsValue: function(){
                // 查询阈值
                tableLogWarningVue.selectMonitorIndexDefault();
            },
            // 关系符号
            changeRelationshipSign: function(){
                // 查询阈值
                tableLogWarningVue.selectMonitorIndexDefault();
                // 邮件模板
                tableLogWarningVue.selectTemplate();
            },
            // 根据用户名查询Account列表
            getAccount: function(){
                // 清空表格
                this.tableLogDate=[];
                tableLogWarningVue.$api.account.queryAccounts("userName",getCookie(global.cookieName))
                .then(res => {
                    this.accountList = res.data;
                    for(var i=0;i<this.accountList.length;i++){
                        this.accountList[i].name=this.accountList[i].name+'('+this.accountList[i].accountTypeName+')';
                    }
                })
                // 查询通知方式
                tableLogWarningVue.alarmWay();
                // 查询报警延时
                tableLogWarningVue.getAlarmDelay();
                //监控时段
                tableLogWarningVue.searchMonitorPeriod();
                // 监控模块查询关联的机器人列表
                tableLogWarningVue.listEnterpriseWechatRobotsByMonitorModule();
            },
            // 监控模块查询关联的机器人列表
            listEnterpriseWechatRobotsByMonitorModule:function(){
                tableLogWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                    "monitorModule":this.monitorModule
                })
                .then(res => {
                    this.enterpriseWechatRobotIdsList = res.data;
                })
            },
            // 查询报警延迟
            getAlarmDelay: function () {
                tableLogWarningVue.$api.alertRule.alarmDelay("userName",getCookie(global.cookieName))
                .then(res => {
                  this.alarmDelayList = res.data;
              })
            },
          // 查询监控时间段
          searchMonitorPeriod: function(){
            this.$api.alertRule.monitorPeriod("userName",getCookie(global.cookieName))
              .then(res => {
                this.monitorPeriodList = res.data;
              })
          },
            // 选择账户
            changeAccount: function(){
                if(this.logWarningForm.account==""||this.logWarningForm.account==null){
                    return;
                }
                // 表格数据为空、显示查询按钮、存储区域为空
                this.tableLogDate=[];
                this.instanceList=[];
                this.isShowSearch=true;
                this.isNextClick=true;
                this.logWarningForm.backupRegion='';
                tableLogWarningVue.$api.account.queryAccountRegions("accountId",this.logWarningForm.account)
                .then(res => {
                    this.backupRegionList = res.data;
                });
                // 查询通知对象
                tableLogWarningVue.queryContacts();
                // 查询联系人组
                tableLogWarningVue.listContactGroups();
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.logWarningForm.backupRegion = []
                if (this.singleBackupRegion) {
                    this.backupRegionList.map((item) => {
                        this.logWarningForm.backupRegion.push(item.name)
                    })
                } else {
                    this.logWarningForm.backupRegion = []
                }
            },
            // 切换存储区域
            changebackupRegion: function(val){
                if (val.length === this.backupRegionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
                // 表格数据为空、显示查询按钮、存储区域为空
                this.tableLogDate=[];
                this.instanceList=[];
                this.isShowSearch=true;
                this.isNextClick=true;
            },
            // 全选 单选
            /***********************************************************************************/
            // 状态
            getState:function(stateStr){
                for(var i=0;i<this.state.length;i++){
                    if(stateStr==this.state[i]){
                        return i;
                    }
                }
                return -1;
            },
            // 单选
            selectChange(selection){
                // 所有数据
                this.selection=selection;
                // 清空数组
                this.newTableLogDateList=[];
                for(var i=0;i<this.selection.length;i++){
                    // 状态
                    var state=tableLogWarningVue.getState(this.selection[i].state);  //running
                    var TableLogCopy=new Object();
                    TableLogCopy.instanceId=this.selection[i].instanceId;
                    TableLogCopy.name=this.selection[i].name;
                    TableLogCopy.privateIp=this.selection[i].privateIp;
                    TableLogCopy.state=state;
                    TableLogCopy.region=this.selection[i].region;
                    TableLogCopy.accountId=this.selection[i].accountId;
                    this.newTableLogDateList.push(TableLogCopy);
                }
                // 选了数据 可以点击下一步
                if(this.newTableLogDateList.length==0){
                    this.isNextClick=true;
                }else{
                    this.isNextClick=false;
                }
            },
            // 全选
            selectAll:function(selection){
                // 所有数据
                this.selection=selection;
                // 清空数组
                this.newTableLogDateList=[];
                for(var i=0;i<this.selection.length;i++){
                    // 状态
                    var state=tableLogWarningVue.getState(this.selection[i].state);  //running
                    var TableLogCopy=new Object();
                    TableLogCopy.instanceId=this.selection[i].instanceId;
                    TableLogCopy.name=this.selection[i].name;
                    TableLogCopy.privateIp=this.selection[i].privateIp;
                    TableLogCopy.state=state;
                    TableLogCopy.region=this.selection[i].region;
                    TableLogCopy.accountId=this.selection[i].accountId;
                    this.newTableLogDateList.push(TableLogCopy);
                }
                if(this.selection.length==0){
                    this.isNextClick=true;
                }else{
                    this.isNextClick=false;
                }
            },
            // 创建报警
            /**********************************************************************************/
            ok: function(name){
                this.$refs[name].validate(valid => {
                    if(valid){
                        var alertList={
                            "alertRuleName": this.logWarningForm.ruleName,
                            "monitorIndex": this.logWarningForm.monitorIndex,
                            "cycle": this.logWarningForm.cycle,
                            "continousCycle": this.logWarningForm.continousCycle,
                            "statisticsValue": this.logWarningForm.statisticsValue,
                            "relationshipSign": this.logWarningForm.relationshipSign,
                            "thresholdStringValue": this.logWarningForm.thresholdValue,
                            "accountId": this.logWarningForm.account,
                            "monitorModule": this.monitorModule,
                            "noticeType": this.logWarningForm.noticeType,
                            "instanceDTOList": this.newTableLogDateList,
                            "delay":this.logWarningForm.alarmDelay,
                            "monitorPeriod":this.logWarningForm.monitorPeriod,
                            "contactType":this.logWarningForm.contactType,
                            "enterpriseWechatRobotIds":this.logWarningForm.enterpriseWechatRobotIds
                        };

                        // 如果联系方式是联系人 传通知对象
                        if(this.logWarningForm.contactType == 0){
                            alertList.contactIDs = this.logWarningForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.logWarningForm.contactType == 1){
                          alertList.contactGroupIds = this.logWarningForm.contactGroupIds;
                        }


                        if(this.logWarningForm.id>0){
                            alertList.id=this.logWarningForm.id;
                            alertList.instanceDTOList=this.newTableLogDateList;
                            // 编辑日志告警
                            this.addloading=true;
                            tableLogWarningVue.$api.alertRule.updateAlertRule(alertList)
                            .then(res => {
                                this.data = res.data;
                                setTimeout(() => {
                                    this.reload();
                                    tableLog.methods.showAll();
                                    this.logWarningForm.notificationObject=[];
                                    this.$refs[name].resetFields();
                                    this.loading = false;
                                    this.$emit('on-ok',this.form);
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success(this.$t('common.editSuccess'));
                                    // 禁止点击下一步
                                    this.isNextClick=true;
                                    this.isShowSearch=false;
                                    this.isShowEmail = false;
                                    this.isShowWeChat = false;
                                    this.addloading=false;
                                    this.modal = false;
                                    this.wechatWarningVisible=false;
                                    this.isAddOrEdit=true;
                                },1000);
                            })
                        }else{
                            // 添加告警
                            this.addloading=true;
                            alertList.instanceDTOList=this.newTableLogDateList;
                            tableLogWarningVue.$api.alertRule.createAlertRule(alertList)
                            .then(res => {
                                this.data = res.data;
                                setTimeout(() => {
                                    this.reload();
                                    tableLog.methods.showAll();
                                    this.logWarningForm.notificationObject=[];
                                    this.$refs[name].resetFields();
                                    this.loading = false;
                                    this.$emit('on-ok',this.form);
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success(this.$t('common.addSuccess'));
                                    // 禁止点击下一步
                                    this.isNextClick=true;
                                    this.isShowEmail = false;
                                    this.isShowWeChat = false;
                                    this.addloading=false;
                                    this.modal = false;
                                    this.wechatWarningVisible=false;
                                    this.isAddOrEdit=true;
                                },1000);
                            })
                        }

                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if(this.logWarningForm.id>0){
                            this.$Message.error(this.$t('common.editFail'));
                        }else{
                            this.$Message.error(this.$t('common.addFail'));
                        }
                    }
                });
            },
            // 取消
            cancel: function(name){
                this.wechatWarningVisible=false;
                this.isAddOrEdit=true;
                this.isShowSearch=false;
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.isNextClick=true;
                this.modal=false;
                this.$emit('on-cancel');
                this.logWarningForm.notificationObject=[];
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                // 清空表格
                this.tableLogDate=[];
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/log/AddOrUpdateLogWarning.vue